import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Divider, Button, Typography } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const styles = theme => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.background,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > hr': {
      alignSelf: 'stretch',
      height: 'auto'
    },
    [theme.breakpoints.down('sm')]: {
      flexFlow: 'column'
    }
  },
  buttons: {
    width: '300px'
  },
  faqSection: {
    width: '100%',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1)
    }
  },
  faq: {
    display: 'flex',
    flexFlow: 'column'
  },
  title: {
    fontWeight: 800
  },
  faqQuestion: {
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(0.25),
    textDecoration: 'none',
    color: '#403f41'
  }
});

const FaqSection = ({ classes }) => {
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <div className={classes.faqSection}>
        <Typography variant="h6" className={classes.title}>
          Preguntas frecuentes
        </Typography>
        <div className={classes.faq}>
          <Typography
            className={classes.faqQuestion}
            component={Link}
            to="/como-funciona/como-comprar"
          >
            Qué pasa si la vendedora no me envía el producto?
            <ChevronRight color="primary" />
          </Typography>
          <Typography
            className={classes.faqQuestion}
            component={Link}
            to="/como-funciona/como-comprar"
          >
            Qué pasa si lo que compré no me queda bien?
            <ChevronRight color="primary" />
          </Typography>
          <Typography
            className={classes.faqQuestion}
            component={Link}
            to="/como-funciona/como-comprar"
          >
            Cómo son los medios de pago?
            <ChevronRight color="primary" />
          </Typography>
          <Typography
            className={classes.faqQuestion}
            component={Link}
            to="/como-funciona/como-comprar"
          >
            Cuáles son las formas de envío?
            <ChevronRight color="primary" />
          </Typography>
        </div>
      </div>
      <Divider orientation="vertical" />
      <div className={classes.faqSection}>
        <Typography variant="h6" className={classes.title}>
          Te quedan más dudas?
        </Typography>
        <Button
          variant="contained"
          color="primary"
          className={classes.buttons}
          component={Link}
          to="/como-funciona/como-comprar"
        >
          {t('lookHowItWorks', { ns: 'products' })}
        </Button>
        <Button variant="contained" color="primary" className={classes.buttons}>
          {t('contactUs', { ns: 'products' })}
        </Button>
      </div>
    </div>
  );
};

export default withStyles(styles)(FaqSection);
